import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import { getDate, getDobDate } from "../../common/DisplayDate";
import getPersonName from "../../common/Name";
import getSsn from "../../common/Ssn";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class HuntingFishingLicenses extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const records = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].huntingFishingLicenses[0].huntingFishingLicense"
      );
      if (records !== undefined) {
        _.forEach(records, (record, index) => {
          rows.push(
            <Table.Row key={`row_hun_fish_name_${index}`}>
              <Table.Cell width={3}> Name: </Table.Cell>
              <Table.Cell width={7}>
                {getPersonName(
                  _.get(record, "name[0].first[0]._", ""),
                  _.get(record, "name[0].middle[0]._", ""),
                  _.get(record, "name[0].last[0]._", ""),
                  props
                )}
              </Table.Cell>
              <Table.Cell width={2}>License Type:</Table.Cell>
              <Table.Cell width={3}>
                {_.get(record, "licenseType[0]._", "")}
              </Table.Cell>
            </Table.Row>
          );

          rows.push(
            <Table.Row key={`row_hun_fish_address_${index}`}>
              <Table.Cell width={3}> Address: </Table.Cell>
              <Table.Cell width={8}>
                {_.get(record, "address[0]") !== undefined && (
                  <Address addressNode={record.address[0]} {...this.props} />)
                }
              </Table.Cell>
              <Table.Cell width={2}>License State:</Table.Cell>
              <Table.Cell width={3}>
                {_.get(record, "licenseState[0]._", "")}
              </Table.Cell>
            </Table.Row>
          );

          const licenseDate = _.get(record, "licenseDate");
          rows.push(
            <Table.Row key={`row_hun_fish_dob_${index}`}>
              <Table.Cell width={3}> Date of Birth: </Table.Cell>
              <Table.Cell width={8}>
                {getDobDate(_.get(record, "DOB[0]"), {
                  userAccount: this.props.userAccount,
                })}
              </Table.Cell>
              <Table.Cell width={2}>License Date:</Table.Cell>
              <Table.Cell width={3}>
                {licenseDate && getDate(licenseDate)}
              </Table.Cell>
            </Table.Row>
          );

          rows.push(
            <Table.Row key={`row_hun_fish_ssn_${index}`}>
              <Table.Cell width={3}> SSN: </Table.Cell>
              <Table.Cell width={8}>
                {getSsn(_.get(record, "SSN[0]._"), this.props)}
              </Table.Cell>
              <Table.Cell width={2}>Home State:</Table.Cell>
              <Table.Cell width={3}>
                {_.get(record, "homeState[0]._", "")}
              </Table.Cell>
            </Table.Row>
          );

          rows.push(
            <Table.Row key={`row_hun_fish_gender_${index}`}>
              <Table.Cell width={3}> Gender: </Table.Cell>
              <Table.Cell width={8}>{_.get(record, "sex[0]._", "")}</Table.Cell>
              <Table.Cell width={2} />
              <Table.Cell width={3} />
            </Table.Row>
          );

          rows.push(
            <Table.Row key={`row_hun_fish_race_${index}`}>
              <Table.Cell width={3}> Race: </Table.Cell>
              <Table.Cell width={8}>
                {_.get(record, "race[0]._", "")}
              </Table.Cell>
              <Table.Cell width={2} />
              <Table.Cell width={3} />
            </Table.Row>
          );
        });
        recCount = records.length;
      } else {
        rows.push(
          <Table.Row key={`no_recs_row`}>
            <Table.Cell colSpan={2}>No Records found</Table.Cell>
          </Table.Row>
        );
      }
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Hunting and Fishing Licenses Registered to the Subject"}
        rows={this.state.rows}
      />
    );
  }
}

export default HuntingFishingLicenses;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/HuntingFishingLicenses.js